import { z } from "zod";

// TODO: Copied (partially)from firebase/lmt/src/common/types. Replace the file there with imports from this file and move tests if any.

export const RequestOutcome = z.enum([
    "notBooked",
    "booked",
    "noBookingNeeded",
    "memberCancelled",
    "noActionNeeded",
]);

export type RequestOutcome = z.infer<typeof RequestOutcome>;

export const RequestBookingOutcome = z.enum([
    "firstChoiceBooked",
    "alternativeChoiceBooked",
]);

export type RequestBookingOutcome = z.infer<typeof RequestBookingOutcome>;
